<hhsg-mapping #mappingComponent pageName="JobTitleMapping" entityName="Job Title" searchByText="Job Title" [sortOptions]="sortOptions" 
    [mappingService]="_jobTitleMappingService" [(mappingForm)]="mappingForm"
    [getDisplayName]="getDisplayName" 
    [mappingDetailTemplate]="customMappingDetailTemplate">
    <ng-template #customMappingDetailTemplate let-mapping>
        <li class="modified">
            <span class="label">SMT Job Title</span>
            <span class="value">{{ mapping.isMapped ? getJobTitleName(mapping.jobTitleId) : "Unmapped" }}</span>
        </li>
    </ng-template>
    <div mappingFormBody class="body" *ngIf="mappingComponent.selection">
        <form #mappingForm="ngForm">
            <div class="form-group">
                <label>Client Job Title</label>
                <input maxlength="75" type="text" required name="jobTitleName " [disabled]="true" [(ngModel)]="mappingComponent.selection.clientJobTitle">
            </div>
            <div class="form-group">
                <label>SMT Job Title Mapping</label>
                <select name="mappedJobTitle" *ngIf="allJobTitles" [(ngModel)]="mappingComponent.selection.jobTitleId">
                    <option value="0" disabled selected></option>
                    <option *ngFor="let jobTitle of allJobTitles" [value]="jobTitle.id">{{ jobTitle.position }}</option>                  
                </select>
            </div>
            <div class="form-group">
                <label>File Source</label>
                <input type="text" required name="costCenterSource" [disabled]="true" value="Time & Attendance">
            </div>
         </form>
    </div>
</hhsg-mapping>